<template xmlns="http://www.w3.org/1999/html">
  <div class="row">
    <div class="col-2">
      <form-group label="Coorientador?">
        <label class="form-check form-switch form-check-custom form-check-solid">
          <input class="form-check-input mt-2" type="checkbox" v-model="hasCoorientador" @click="model.clearErrors('Coorientador_ID')">
        </label>
      </form-group>
    </div>

    <div class="col-3" :class="{'d-none': !hasCoorientador}">
      <form-group label="Coorientador" required :is-invalid="model.errors.Coorientador_ID">
        <template #actions>
          <a href="#" class="float-end" data-bs-toggle="modal" data-bs-target="#modal_orientador">Não encontrou?</a>
        </template>
        <select class="form-select" data-control="select2" v-select2 data-placeholder="Selecione uma opção"
                v-model="model.Coorientador_ID"
                @change="atualizaDadosOrientador($event.target.value)"
                ref="widgetOrientador">
          <option></option>
          <option v-for="orientador in orientadores" :value="orientador.id" >{{ orientador.nome }}</option>
        </select>
        <span class="fw-bold opacity-40 text-muted" v-if="orientador.formacao">{{ orientador.titulacao }} | {{ orientador.formacao }}</span>
      </form-group>
    </div>

    <div :class="{'col-4': hasCoorientador, 'col-7': !hasCoorientador}">
      <form-group label="Escola" required :is-invalid="model.errors.Escola_ID">
        <template #actions v-if="!inscricoesFinalizadas">
          <a href="#" class="float-end" data-bs-toggle="modal" data-bs-target="#modal_escola">Não encontrou?</a>
        </template>
        <select class="form-select" data-control="select2" v-select2 data-placeholder="Selecione uma escola"
                v-model="model.Escola_ID"
                :disabled="canEdit"
                @change="model.clearErrors('Escola_ID')"
                ref="widgetEscola">
          <option></option>
          <option v-for="escola in escolas" :value="escola.id" >{{ escola.nome }}</option>
        </select>
      </form-group>
    </div>

    <div class="col-3 mt-7">
      <a href="#" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal_aluno">Adicionar aluno</a>
    </div>

  </div>

  <div class="row mt-4">
    <div class="col-12">
      <div class="rounded border p-5 mb-5 mt-6" :class="{'border-danger': model.errors.alunos}">
        <div class="row">
          <div class="col-3" :class="{'border-danger': model.errors['alunos.'+index], 'd-none': Object.keys(form.alunos[index]).length === 0}" v-for="(aluno, index) in form.alunos" v-if="form.alunos.length > 0">
            <div class="card card-bordered mt-2 p-0">
              <div class="card-body ribbon ribbon-top pt-7 p-2">
                <div class="ribbon-label">
                  <i class="bi bi-trash cursor-pointer text-white" @click="removeAluno(index)"></i>
                  <span class="ribbon-inner bg-info"></span>
                </div>

                <h5 class="card-title text-truncate">{{ aluno.nome }}</h5>
                <span class="card-subtitle">
                  <span class="badge badge-danger">{{ aluno.camiseta }}</span>
                  <span class="badge badge-info ms-2">{{ genero(aluno.genero) }}</span>
                  <span class="badge badge-success ms-2">{{ aluno.cpf }}</span>
                  <span class="badge badge-dark ms-2">{{ aluno.telefone }}</span>
                  <span class="badge badge-secondary d-block mt-2">{{ aluno.email }}</span>
                </span>
              </div>
              <span class="text-danger" v-if="{'border-danger': model.errors['alunos.'+index]}">{{model.errors['alunos.'+index]}}</span>
            </div>
          </div>
        </div>

        <div class="text-center p-5" v-if="form.alunos.length === 0">
          <label class="fs-6 fw-bold form-label">Nenhum aluno selecionado, utilize o botão acima para adicionar, ou
            <a href="#" data-bs-toggle="modal" data-bs-target="#modal_aluno">clique aqui!</a> para adicionar</label>
        </div>
        <span class="text-danger" v-if="model.errors.alunos">{{model.errors.alunos}}</span>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <form-group label="Nome do Projeto" :is-invalid="model.errors.InscricaoNomeProjeto">
        <input
            v-model="model.InscricaoNomeProjeto"
            class="form-control mb-2"
            type="text"
            placeholder="Nome do Projeto"
            @blur="model.clearErrors('InscricaoNomeProjeto')"
            :class="{'is-invalid' : model.errors.InscricaoNomeProjeto}"
            maxlength="150"
        />
      </form-group>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-3">
      <form-group label="Área de Conhecimento" required :is-invalid="model.errors.ProjetoAreaConhecimento">
        <select class="form-select" v-model="model.ProjetoAreaConhecimento"
                data-placeholder="Selecione uma opção"
                :disabled="inscricoesFinalizadas"
                @change="model.clearErrors('ProjetoAreaConhecimento')" data-control="select2" v-select2>
          <option></option>
          <option value="1">Ciências Agrárias</option>
          <option value="2">Ciências Exatas e da Terra</option>
          <option value="3">Ciências Biológicas e da Saúde</option>
          <option value="4">Ciências Humanas e Sociais</option>
          <option value="5">Linguística, Letras e Artes</option>
        </select>
      </form-group>
    </div>

    <div class="col-3">
      <form-group label="Categoria" required :is-invalid="model.errors.Categoria_ID">
        <select class="form-select" data-control="select2" v-select2 data-placeholder="Selecione uma opção"
                v-model="model.Categoria_ID"
                :disabled="inscricoesFinalizadas"
                @change="buscaAnoEscolaridade(); model.clearErrors('Categoria_ID')">
          <option></option>
          <option v-for="categoria in categorias" :value="categoria.id" >{{ categoria.nome }}</option>
        </select>
      </form-group>
    </div>

    <div class="col-3">
      <form-group label="Ano Escolaridade" required :is-invalid="model.errors.AnoEscolaridade_ID">
        <select class="form-select" data-control="select2" v-select2 data-placeholder="Selecione uma categoria"
                v-model="model.AnoEscolaridade_ID"
                :disabled="inscricoesFinalizadas"
                @change="model.clearErrors('AnoEscolaridade_ID');">
          <option></option>
          <option :key="ano.id" v-for="ano in anoEscolaridade" :value="ano.id" >{{ ano.nome }}</option>
        </select>
      </form-group>
    </div>

    <div class="col-2">
      <form-group label="Necessita de Ponto de Energia?" :is-invalid="model.errors.ProjetoPontoEnergia">
        <label class="form-check form-switch form-check-custom form-check-solid">
          <input class="form-check-input mt-2" type="checkbox" v-model="model.ProjetoPontoEnergia">
        </label>
      </form-group>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-6">
      <form-group label="Questão Problema" :is-invalid="model.errors.InscricaoQuestaoProblema">
        <textarea
            v-model="model.InscricaoQuestaoProblema"
            class="form-control mb-2"
            type="text"
            :disabled="inscricoesFinalizadas"
            rows="15"
            placeholder="Questão Problema"
            @blur="model.clearErrors('InscricaoQuestaoProblema')"
            :class="{'is-invalid' : model.errors.InscricaoQuestaoProblema}"
            maxlength="250"></textarea>
        <span class="text-muted">{{caracteresRestantes(250, 'InscricaoQuestaoProblema')}}</span>
      </form-group>
    </div>

    <div class="col-6">
      <form-group label="Introdução" :is-invalid="model.errors.InscricaoIntroducao">
        <textarea
            v-model="model.InscricaoIntroducao"
            class="form-control mb-2"
            type="text"
            :disabled="inscricoesFinalizadas"
            rows="15"
            placeholder="Introdução"
            @blur="model.clearErrors('InscricaoIntroducao')"
            :class="{'is-invalid' : model.errors.InscricaoIntroducao}"
            maxlength="1800"></textarea>
        <span class="text-muted">{{caracteresRestantes(1800, 'InscricaoIntroducao')}}</span>

      </form-group>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-6">
      <form-group label="Desenvolvimento" :is-invalid="model.errors.InscricaoAbordagemTeorica">
        <textarea
            v-model="model.InscricaoAbordagemTeorica"
            class="form-control mb-2"
            type="text"
            :disabled="inscricoesFinalizadas"
            rows="15"
            placeholder="Desenvolvimento"
            @blur="model.clearErrors('InscricaoAbordagemTeorica')"
            :class="{'is-invalid' : model.errors.InscricaoAbordagemTeorica}"
            maxlength="1200"></textarea>
        <span class="text-muted">{{caracteresRestantes(1200, 'InscricaoAbordagemTeorica')}}</span>

      </form-group>
    </div>

    <div class="col-6">
      <form-group label="Referências Bibliográficas" :is-invalid="model.errors.InscricaoReferencia">
        <textarea
            v-model="model.InscricaoReferencia"
            class="form-control mb-2"
            :disabled="inscricoesFinalizadas"
            type="text"
            rows="15"
            placeholder="Referências Bibliográficas"
            @blur="model.clearErrors('InscricaoReferencia')"
            :class="{'is-invalid' : model.errors.InscricaoReferencia}"
            maxlength="600"></textarea>
        <span class="text-muted">{{caracteresRestantes(600, 'InscricaoReferencia')}}</span>

      </form-group>
    </div>
  </div>
  <aluno-modal></aluno-modal>
  <orientador-modal @success="buscaOrientadores"></orientador-modal>
  <escola-modal @success="atualizaEscola"></escola-modal>
</template>
<script>
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import AlunoModal from "./AlunoModal";
import axios from "axios";
import OrientadorModal from "../Orientadores/OrientadorModal";
import {error, success} from "@settings/toastr";
import EscolaModal from "./EscolaModal";

export default {
  props: {
    form: {
      type: Object
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EscolaModal,
    OrientadorModal,
    FormGroup,
    SubmitButton,
    AlunoModal
  },

  data: _ => ({
    model: {},
    escolas: [],
    categorias: [],
    anoEscolaridade: [],
    orientadores: [],
    hasCoorientador: false,
    orientador: {
      formacao: null,
      titulacao: null
    },
    inscricoesFinalizadas: false
  }),

  created() {
    this.inscricoesFinalizadas = this.$page.props.configs.inscricoes_finalizadas
    this.init();
  },

  methods: {
    async init() {

      this.form.processing = true
      this.model = this.form;

      if (!this.editing) {
        this.model.Orientador_ID = this.$page.props.globalVar.orientadorID;
        this.model.defaults('Orientador_ID', this.$page.props.globalVar.orientadorID)
      }

      this.buscaEscolas()
      await this.buscaOrientadores()
      await this.buscaCategorias()

      if (this.editing) {
        this.buscaAnoEscolaridade()
      }
      this.form.processing = false

      this.hasCoorientador = !!this.model.Coorientador_ID
    },

    buscaEscolas() {
      axios.get(this.route('app.core.escolas')).then(response => {
        this.escolas = response.data
      })
    },

    async buscaOrientadores(coorientadorId = null) {
      await axios.get(this.route('app.core.orientadores')).then(response => {
        this.orientadores = response.data
      })

      if (coorientadorId) {
        this.model.Coorientador_ID = coorientadorId

        await this.$nextTick() // wait for DOM to update
        $(this.$refs.widgetOrientador).select2()
        this.atualizaDadosOrientador(coorientadorId)
      }
    },

    async atualizaEscola(escolaId = null) {
      await this.buscaEscolas()

      if (escolaId) {
        this.model.Escola_ID = escolaId

        await this.$nextTick() // wait for DOM to update
        $(this.$refs.widgetEscola).select2()
        this.model.clearErrors('Escola_ID')
      }
    },

    buscaCategorias() {
      axios.get(this.route('app.core.categorias')).then(response => {
        this.categorias = response.data
      })
    },

    buscaAnoEscolaridade() {
      if (!this.editing) {
        this.model.AnoEscolaridade_ID = null
      }
      axios.get(this.route('app.core.ano-escolaridade', {'categoria_id': this.model.Categoria_ID})).then(response => {
        this.anoEscolaridade = {...response.data}
      })
    },

    adicionaAluno(aluno) {
      let verify = this.form.alunos.find(a => a.id === aluno.id)

      if (this.form.alunos.length === 4) {
        error({'error': 'Não é possível adicionar mais alunos!'})
        return
      }

      if (!verify) {
        this.form.alunos.push(aluno)
        this.model.clearErrors('alunos')
        success('Aluno adicionado ao projeto!')
        return
      }

      error({'error': 'Aluno já adicionado ao projeto!'})
    },

    removeAluno(index) {
      this.model.clearErrors('alunos')
      this.model.clearErrors('alunos.'+index)
      this.form.alunos[index] = {}
      // this.form.alunos.splice(index, 1)
    },

    atualizaDadosOrientador(id = null) {
      this.model.clearErrors('Coorientador_ID')

      if (!id) {
        $(this.$refs.widgetOrientador).val('').trigger('change')
        this.orientador.titulacao = null
        this.orientador.formacao = null
        return
      }

      let orientador = this.orientadores.find(orientador => orientador.id === parseInt(id))
      this.orientador.titulacao = orientador.titulacao
      this.orientador.formacao = orientador.formacao.nome
    },

    genero(genero) {
      switch (genero) {
        case 'M':
          return 'Masculino'
          break;
        case 'F':
          return 'Feminino'
          break;
        default:
          return 'Outro'
      }
    },
    caracteresRestantes(limit, input) {
      var char = this.form[input]?.length;
      let count = char ? (limit - char) + " / " + limit : limit + " / " + limit
      return count + " caracteres restantes.";
    },
  },
  computed: {
    canEdit () {
      return this.inscricoesFinalizadas && !this.can('ADM')
    }
  },

  watch: {
    hasCoorientador(newValue, oldValue) {
      if (newValue === true) {
        this.atualizaDadosOrientador(this.model.Coorientador_ID)
      } else {
        this.atualizaDadosOrientador()
        this.model.Coorientador_ID = null
      }
    }
  }
}
</script>
